var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThunder = function SvgThunder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M17.5 6.975h-4.918l4.422-5.587a.18.18 0 0 0-.14-.29h-8.56a.18.18 0 0 0-.155.089l-5.783 9.989a.178.178 0 0 0 .154.268h3.893l-1.996 7.982c-.042.174.168.297.297.172L17.623 7.28a.177.177 0 0 0-.123-.306m-10.487 8.33 1.346-5.38H4.846l4.232-7.307h5.013l-4.65 5.877h4.71z"
  })));
};
export default SvgThunder;